/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-multi-spaces */

/**
 * Defines valid Units of Measure as defined by the CTC Platform.
 */
export enum Unit {
  US       = 'US',
  METRIC   = 'Metric',
  IMPERIAL = 'Imperial',
  DEVICE   = 'Device',
  MIXED    = 'Mixed',
  SI       = 'SI',
};

// defines time units
export enum TimeUnits {
  Hours = 'hours',
  Minutes = 'minutes',
  seconds = 'seconds'
};

/**
  * @function isValidUnit
  *
  * Given a unit of measure, determines if the unit is a supported, valid unit of
  * measure as supported by the CTC Platform. Valid values are defined within the
  * Unit enumeration (i.e. US, METRIC, DEVICE, MIXED, and SI).
  *
  * @param   {string} unit The unit against which to test for validity.
  * @returns {boolean} true if the unit is valid, otherwise false.
  */
export const isValidUnit = (unit: string): boolean => {
  return unit ? Boolean(Unit[unit.toUpperCase()]) : false;
};

export default Unit;
